module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/news/introducing-sophie-baldwin/"},"frontmatter":{"title":"Introducing... Sophie Baldwin","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450 introducing sophie baldwin article header-d2f7e935d5f333236b87bb6da17a48b8.jpg"}}},"original":"/img/1160x450 introducing sophie baldwin article header.jpg"},"category":"Culture"}}}]}},"pathContext":{"tag":"Introducing to RLA"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-introducing-to-rla.json
// module id = 1820
// module chunks = 200057202546481